import { render, staticRenderFns } from "./events-journal-syslog.vue?vue&type=template&id=7af9c75a"
import script from "./events-journal-syslog.vue?vue&type=script&lang=ts"
export * from "./events-journal-syslog.vue?vue&type=script&lang=ts"
import style0 from "./events-journal-syslog.vue?vue&type=style&index=0&id=7af9c75a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports